import { normalizeAPIError } from './errors'

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
    ...init,
  })

  if (res.status === 204) return undefined as T

  const contentType = res.headers?.get?.('content-type') || ''
  const body = contentType.includes('application/json') ? await res.json() : await res.text()
  if (!res.ok) {
    throw normalizeAPIError(body)
  }
  return body as T
}
